import React, { useState } from 'react';
import { Button, FormLabel, Typography, IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    }
}));

export default function NotesDialog(props) {
    const currentTheme = props.currentTheme;
    const classes = useStyles();
    const [notes, setNotes] = useState(props.Notes);

    const saveNotes = () => {
        props.onSave(notes);
        props.onCloseDialog();
    };
    
    return (
        <div>
            <Dialog maxWidth='sm' open={props.openDialog} onClose={props.onCloseDialog} fullWidth={true} aria-labelledby="max-width-dialog-title" disableBackdropClick={true}>
                <MuiDialogTitle disableTypography className={classes.root}>
                    <Typography variant="h6">Add Notes</Typography>
                    {props.openDialog ? (
                        <IconButton aria-label="close" className={classes.closeButton} onClick={props.onCloseDialog}>
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </MuiDialogTitle>
                <DialogContent className={classes.root} dividers>
                    <DialogContentText style={{ marginBottom: '0px' }}>
                        <FormLabel style={{ color: currentTheme.secondary }}>Notes for : {props.RoundLocation}</FormLabel>
                    </DialogContentText>
                    <TextField fullWidth
                        id="notes"
                        label="Notes"
                        placeholder="Notes"
                        multiline
                        rows="4"
                        columns="100"
                        variant="outlined"
                        value={notes}
                        onChange={e => setNotes(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained"
                        color="primary"
                        size="small"
                        style={{ background: currentTheme.secondary, width: "100px" }}
                        startIcon={<SaveIcon />}
                        onClick={saveNotes}
                    >
                        Save
                    </Button>
                    <Button variant="contained"
                        color="secondary"
                        size="small"
                        style={{ width: "100px", marginRight: "20px" }}
                        startIcon={<CancelIcon />}
                        onClick={props.onCloseDialog}
                        autoFocus
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
